// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_seeAll_card__2Hlt-","title":"Card_seeAll_title__3vM2s","genre":"Card_seeAll_genre__3eNnA"};